import React from 'react';
import classNames from 'classnames';
import { OrderSummaryItemProps } from './props';

import styles from './OrderSummaryItem.module.css';

const OrderSummaryItem: React.FunctionComponent<OrderSummaryItemProps> = (
  {
    description,
    price,
    crossedPrice,
    redPrice,
    fullWidthDescription,
    rowClassName,
  },
) => {
  const priceStyles = redPrice ? `${styles.orderText} ${styles.orderTextRed}` : styles.orderText;
  const descriptionStyles = fullWidthDescription ? `${styles.orderText} ${styles.fullWidth}` : styles.orderText;
  const className = rowClassName ? styles[rowClassName] : '';

  return (
    <div className={classNames(styles.orderRow, className)}>
      <div className={descriptionStyles}>{description}</div>
      <div className={styles.prices}>
        {crossedPrice && (
          <div className={`${styles.orderText} ${styles.crossedPrice}`}>{crossedPrice}</div>
        )}
        {price && <div className={priceStyles}>{price}</div>}
      </div>
    </div>
  );
};

export default OrderSummaryItem;
